import {useState} from "react";
import {Checkbox} from "antd";
import {NavLink, useHistory} from "react-router-dom";
import API_LINK from "../components/links/Link";
import {toast} from "react-toastify";
import $ from 'jquery';
import {LOGO_NEW} from "../assets/images/Images";
import '../assets/css/auth.css'

export default function Login() {
    document.title = "Account";
    const history = useHistory();
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')

    async function submitHandle(event) {
        event.preventDefault();
        event.stopPropagation();
        var form = $('.SubmitForm');
        let formdata = new FormData(form[0]);
        let toaster;
        if (!form[0].checkValidity()) {
            toast.warn("Fill all the required(*) fields.")
        } else {
            form.find("button").attr("disabled", true);
            toaster = toast.loading("Processing...");
            try {
                formdata.append("page", "AdminLogin");
                var requestOptions = {
                    method: 'POST', body: formdata, redirect: 'follow'
                };

                fetch(`${API_LINK}Authentication.php`, requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        console.log(result);
                        if (result.status === 1) {
                            setTimeout(() => {
                                if (result.data.length > 0) {
                                    let user = result.data[0];
                                    localStorage.setItem("UserId", user.id)
                                    localStorage.setItem("UserName", user.UserName)
                                    localStorage.setItem("Email", user.Email)
                                    localStorage.setItem("Avatar", user.Avatar)
                                    localStorage.setItem("Password", user.Password)
                                    toast.update(toaster, {
                                        type: "success",
                                        render: "You have successfully logged in. Please wait! redirecting...",
                                        isLoading: false,
                                        autoClose: toaster,
                                        closeButton: true,
                                        pauseOnHover: false,
                                        pauseOnFocusLoss: false,
                                        closeOnClick: true,
                                    })
                                    form.find("button").attr("disabled", false);
                                    form.trigger("reset");
                                    setTimeout(() => {
                                        history.push("/user/dashboard");
                                    }, 1500)
                                } else {
                                    toast.update(toaster, {
                                        type: "warning",
                                        render: "Wrong credentials. Please make sure to enter accurate information",
                                        isLoading: false,
                                        autoClose: toaster,
                                        closeButton: true,
                                        pauseOnHover: false,
                                        pauseOnFocusLoss: false,
                                        closeOnClick: true,
                                    })
                                    form.find("button").attr("disabled", false);
                                }
                            }, 1000)
                        } else {
                            toast.error("Server Error! Please try again later.")
                        }
                    })
                    .catch(error => console.log('error', error));
            } catch (e) {
                console.log(e);
            }

        }
    }


    return (<>
        <div className="container">
            <div className="center-form">
                <div className="auth-form-container">
                    <div className="auth-logo">
                        <img src={LOGO_NEW} alt="logo"/>
                    </div>
                    <form onSubmit={submitHandle} className='SubmitForm'>
                        <div className="auth-form">
                            <div className="form-group">
                                <label>Email <code>*</code></label>
                                <input type="email" autoFocus placeholder={'example@gmail.com'} name={'email'} required
                                       value={email}
                                       onChange={event => setEmail(event.target.value)}/>
                            </div>
                            <div className="form-group">
                                <label>Password <code>*</code></label>
                                <input type="password" placeholder={'......'} required value={password}
                                       name={'password'}
                                       onChange={event => setPassword(event.target.value.trim())}/>
                            </div>
                            <div className="form-group">
                                <Checkbox defaultChecked>Keep me sign in</Checkbox>
                            </div>
                            <div className="form-group">
                                <button type={'submit'} className='btn btn-primary'>Sign In</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </>)
}
